import { useQuery } from '@tanstack/react-query';
import { truckingIntegrationService } from '@/api/services/TruckingIntegrationService';
import { useAuth } from '@/stores/authContext';

export const INTEGRATION_QUERY_KEY = ['carrierIntegration'] as const;

// Конфигурация «Интеграции» перевозчика (server-state). Включён только при авторизации.
// Повтор — глобально off (403 «не аттестован» не повторяем; обрабатываем в компоненте по статусу).
export function useIntegration() {
  const { isAuthenticated } = useAuth();
  return useQuery({
    queryKey: INTEGRATION_QUERY_KEY,
    queryFn: () => truckingIntegrationService.getIntegration(),
    enabled: isAuthenticated,
    staleTime: 5 * 60_000,
  });
}
